import common from './common';

export default {
	GALLERY_ID_DRAW_IT: 0,
	GALLERY_ID_COLOUR_IT: 1,
	ARR_COLOUR_IT_SPRITE_ID: [
		'colour_image_1',
		'colour_image_2',
		'colour_image_3',
		'colour_image_4',
		'colour_image_5',
		'colour_image_6',
		'colour_image_7',
		'colour_image_8',
		'colour_image_9',
		'colour_image_10',
		'colour_image_11',
		'colour_image_12',
		'colour_image_13',
		'colour_image_14'
	],
	ARR_DRAW_IT_SPRITE_ID: [
		'draw_image_1',
		'draw_image_2',
		'draw_image_3',
		'draw_image_4',
		'draw_image_5',
		'draw_image_6',
		'draw_image_7_'
	],
	TUT_EVENT: {
		TOOL_BAR_HIDDEN: 0,
		TOOL_BAR_VISIBLE: 1,
		PALETTE_SELECTED: 2,
		PALETTE_PANEL_HIDDEN: 3,
		TOOL_SELECTED: 4,
		CANVAS_DRAWN: 5,
		CANVAS_VISIBLE: 6,
		PALETTE_BUTTON_ENABLED: 7,
		PALETTE_BUTTON_DISABLED: 8,
		MENU_PANEL_SHOWN: 9,
		MENU_PANEL_HIDDEN: 10
	},
	TOOL: {
		PENCIL: 0,
		BRUSH: 1,
		STAMP: 2,
		BUCKET: 3,
		INK_POT: 4,
		SPRAY: 5,
		ERASER: 6
	},
	GALLERY_BORDER_TINT: [
		0x87d027, // Draw it!
		0x1e84c9 // Colour it!
	],
	TEXTURE_BUTTON_BASE_ID: 'btns_colour_texture',
	TEXTURE_SPRITE_BASE_ID: 'texture_fill',
	CANVAS_HEIGHT: 612,
	CANVAS_WIDTH: 870,
	selectedGallery: null,
	selectedImageId: null,
	selectImage: null,
	drawItTextId: null,
	createCanvasBg: function(panelTexture) {
		//const SCALE_FACTOR = 0.979;
		const SCALE_FACTOR = 1;

		//let galleryKey = 'draw';
		let galleryKey = this.selectedGallery === 1 ? 'colour_it' : 'draw_it';
		//if (this.selectedGallery === 1) galleryKey = 'colour';

		const canvasTex = P3.assets.texture(common.levelConfig.gallery_select.frame[galleryKey]);
		const canvasBg = new PIXI.Graphics();
		canvasBg.beginFill(this.GALLERY_BORDER_TINT[this.selectedGallery], 1);
		canvasBg.drawRoundedRect(
			-canvasTex.width * 0.5 * SCALE_FACTOR,
			-canvasTex.height * 0.5 * SCALE_FACTOR,
			canvasTex.width * SCALE_FACTOR,
			canvasTex.height * SCALE_FACTOR,
			30);
		canvasBg.endFill();

		return canvasBg;
	},
	findColourCode: function(selection) {
		const result = {r: 0, g: 0, b: 1};

		let pages = common.gameConfig['palettePanel']['pages'];
		for (let i = 0; i < pages.length; ++i) {
			const itemIndex = pages[i].indexOf(selection);
			if (itemIndex !== -1) {
				result.r = i;
				result.g = itemIndex;

				break;
			}
		}

		return result;
	}
};
